<div class="card">
  <div class="service">
    <div class="service__left service__left--no-padding">
      <svg-icon src="assets/images/icons/status-{{ healthState() | status_to_icon }}.svg"></svg-icon>
      <div class="service__header-caption">
        @if (showVisual()) {
          <div
            class="service__title-wrapper service__title-wrapper--space-between"
            [class.card--clickable]="true"
            [routerLink]="routerLink()"
          >
            <h3 class="service__title">{{ customerDescription() }}</h3>
            <svg-icon class="service__title-arrow" src="assets/images/icons/arrow-small-right.svg" />
          </div>
        } @else {
          <div class="service__title-wrapper service__title-wrapper--space-between">
            <h3 class="service__title">{{ customerDescription() }}</h3>
          </div>
        }
        <div class="tags">
          @for (tag of tags(); track $index) {
            <div class="tag">{{ tag }}</div>
          }
        </div>
      </div>
    </div>
    <div class="service__flex-table">
      <div class="service__flex-table-row">
        <div class="service__flex-table-col">
          <div class="service__flex-table-title">{{ "ServiceElement.Owner" | translate }}</div>
          <div class="service__flex-table-subtitle">{{ portOwner() }}</div>
        </div>
        <div class="service__flex-table-col">
          <div class="service__flex-table-title">{{ "Services.Fulfilment.Lightpath.Location" | translate }}</div>
          <div class="service__flex-table-subtitle">{{ city() }} ({{ street() }} {{ number() }})</div>
        </div>
      </div>
      <div class="service__flex-table-row">
        <div class="service__flex-table-col">
          <div class="service__flex-table-title">{{ "ServiceElement.PortID" | translate }}</div>
          <div class="service__flex-table-subtitle">{{ portId() | shorten_guid }}</div>
        </div>
        <div class="service__flex-table-col">
          <div class="service__flex-table-title">{{ "Subscription.VLANID" | translate }}</div>
          <div class="service__flex-table-subtitle">
            <span class="port__title">
              @if (showVlanrange()) {
                {{ vlanrange() }}
              } @else {
                {{ "Subscription.UntaggedPort" | translate }}
              }
            </span>
          </div>
        </div>
      </div>
      @if (serviceTag()) {
        <div class="service__flex-table-row">
          <div class="service__flex-table-col">
            <div class="service__flex-table-title">S-TAG</div>
            <div class="service__flex-table-subtitle">{{ serviceTag() }}</div>
          </div>
          <div class="service__flex-table-col">
            <div class="service__flex-table-title"></div>
            <div class="service__flex-table-subtitle"></div>
          </div>
        </div>
      }
    </div>
    <port-visualiser [subscription]="port()" [unavailable]="!showVisual()" />
  </div>
</div>
